import React from "react";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div>
      <div
        className="relative bg-cover bg-center h-screen flex items-center justify-center"
        style={{ backgroundImage: `url('/untitled-1173.0.jpeg')` }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="text-white text-center z-10">
          <h1 className="text-4xl font-extrabold leading-tight mb-4">
            Welcome to Netsi's Kitchen
          </h1>
          <p className="text-lg mb-8">
            Discover our amazing east African food experiences with us.
          </p>

          <Link
            to="menu"
            className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-6 rounded-full transition duration-300"
          >
            Explore Our Menu
          </Link>
        </div>
      </div>
      <div className="bg-amber-400 py-12">
      <div className="container mx-auto flex flex-col md:flex-row items-center">
        {/* Image */}
        <div className="w-full md:w-1/2">
          <img
            src="/artfood.jpeg" // Replace with your image source
            alt="Home Image"
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </div>

        {/* Description */}
        <div className="w-full md:w-1/2 mt-6 md:mt-0 px-4">
          <h2 className="text-3xl font-semibold mb-4">Some Facts About Ethiopian Food</h2>
          <p className="text-gray-700">
          Ethiopian food is one of the world's most unique, fascinating and delicious cuisines. In addition to its flavorful traditional dishes, stews, and spices, Ethiopian cuisine also features a strong culture around how food is served and shared with friends and family.
          </p>
          <p className="text-gray-700 mt-4">
          Eating Ethiopian food is a social event, a shared experience that includes everyone around the table and usually involves eating with ones hands thanks to the use of injera (Ethiopian bread) as a sort of utensil. This is not only delicious but also a shocking amount of fun!
          </p>
          <p className="text-gray-700 mt-4">
            Join us for an unforgettable dining experience, where every bite tells a story of
            tradition, passion, and excellence.
          </p>
        </div>
      </div>
    </div>
    </div>
  );
}

export default Home;
